module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.6ab1d440.png";